import {
  CmsService,
  PageMetaResolver,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
  TranslationService
} from '@spartacus/core'
import { combineLatest } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { CountryService } from '../../site-context/facade/country.service'
import { Injectable } from '@angular/core'
import { MbBasePageMetaResolver } from '../../cms/page/mb-base-page-meta-resolver'

@Injectable({
  providedIn: 'root',
})
export class MiltenyiMyAccountPageMetaResolver extends PageMetaResolver implements PageTitleResolver, PageRobotsResolver {
  page$ = this.cmsService.getCurrentPage()
  pageType = PageType.CONTENT_PAGE
  pageTemplate = 'AccountPageTemplate'

  constructor (protected cmsService: CmsService,
              protected translation: TranslationService,
              protected countryService: CountryService,
              protected mbBasePageMetaResolver: MbBasePageMetaResolver) {
    super()
  }

  resolveTitle () {
    return combineLatest([
      this.page$,
      this.countryService.getActiveCountryNameInNatLang()
    ]).pipe(
      switchMap(([page, activeName]) => this.translation.translate('pageMetaResolver.myAccount.mbTitle', {
          title: page?.title,
          countryName: activeName
        })
      ))
  }

  resolveRobots () {
    return this.mbBasePageMetaResolver.resolveRobots()
  }
}
